var BaseMsgItem = require('./BaseMsgItem');
var $ = require('jQuery');
var template = require('../../template/msg/false-msg-item.html');
/*require('./../../style/msg/text-msg-item.less');*/
var EmotionHandler = require('../../../lib/EmotionHandler');
var XssFilter = require('../../../lib/XssFilter');
var RichTextFormat = require('../../../lib/RichTextFormat');
var html2Text = require('../../utils/html2Text');
var utils = require('./../../global/utils');
var _jsonHandler = utils.jsonHandler;
var _isEmpty = utils.isEmpty;

var _replaceUrlSrc = function (txt) {
  var reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?[^(&nbsp;)]/ig;
  var result = txt.replace(reg, function (item) {
    txt = txt.replace(/&amp;/gi, '&');
    return '<a class="im-msg-action" href="' + item + '" target="_blank">' + item + '</a>';
  });
  return result;
};
var _textToEmotion = function (content) {
  content = content.replace(/(\[[^\[\]]*\])/g, function (item) {
    var emotionID = EmotionHandler.emotionTitles.indexOf(item.replace(/[\[\]]/g, ''));
    //普通文本
    if (emotionID == -1) {
      return item;
    }
    return '<div style="margin-bottom:-3px;margin-left:5px;display:inline-block;" class="im-emotion-' + emotionID + '"></div>';
  });
  return content;
};
var _textFormat = function (content) {
  //换行处理
  content = content.replace(/(\n)/g, '<br>');
  //文本多个空格替换
  content = content.replace(/\s/g, '&nbsp;');
  //链接转换
  content = _replaceUrlSrc(content);
  //表情转换
  content = _textToEmotion(content);
  // xssFilter,将'<'替换成’&lt;将'>'替换成&gt;
  content = XssFilter.doFilter(content);
  return content;
};

var FalseMsgItem = function (options) {
  (function (self) {
    var defaults = {
      template: template
    };
    $.extend(defaults, options);
    BaseMsgItem.call(self, defaults);
  })(this);

  // 是否已经被render过
  this._rendered = false;
};
FalseMsgItem.prototype = Object.create(BaseMsgItem.prototype);
FalseMsgItem.prototype.renderContent = function () {
  var msg = this._data.msg;
  var msgcontent = msg.content;
  var content;
  var extra = !_isEmpty(msgcontent.extra) && typeof msgcontent.extra == 'string' ? _jsonHandler.parse(msgcontent.extra) : {};
  if (!RichTextFormat.isNeedConvert(msgcontent)) {
    content = _textFormat(html2Text(msgcontent.msg));
  } else {
    msgcontent.extra = extra;
    var richtext = msgcontent.extra.richtext_format.richtext;
    msgcontent.extra.richtext_format.richtext = _textFormat(richtext);
    // 富文本转换
    msgcontent.extra = _jsonHandler.stringify(msgcontent.extra);
    msg.content = msgcontent;
    content = RichTextFormat.richTextFormat(msg).content.msg;
  }
  if (msg.is_false_new) {
    if (msg.call_type == "audio" || msg.call_type == "video") {
      this._element.find('.im-msg-content').addClass('im-false-click im-msg-click').data('msg-id', msg.msg_id);
    }
    if (msg.call_type == "audio") {
      this._element.find('.im-msg-main').addClass('im-false-click im-false-msg-audio');
    } else if (msg.call_type == "video") {
      this._element.find('.im-msg-main').addClass('im-false-click im-false-msg-video');
    }
    if (msg.not_answered) {
      this._element.find('.im-msg-main').addClass('not-answered');
    }
  }
  this._element.find('.im-msg-content').html(content);
};

module.exports = FalseMsgItem;
